import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "spinnerContainer" }
const _hoisted_2 = {
  key: 0,
  class: "appMode"
}
const _hoisted_3 = {
  key: 1,
  class: "appVersion"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_op_modal_container = _resolveComponent("op-modal-container")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["appRoot", _ctx.$route.name])
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "blob blob-1" }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "grid-overlay" }, null, -1)),
    _withDirectives(_createElementVNode("div", _hoisted_1, _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "spinner" }, [
        _createElementVNode("div"),
        _createElementVNode("div"),
        _createElementVNode("div"),
        _createElementVNode("div")
      ], -1)
    ]), 512), [
      [_vShow, _ctx.$store.state.showSpinner > 0]
    ]),
    (_ctx.showApp)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.showAppMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Modalità: " + _toDisplayString(_ctx.appMode), 1))
            : _createCommentVNode("", true),
          (_ctx.showVersion)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "v" + _toDisplayString(_ctx.appVersion), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_router_view)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_op_modal_container)
  ], 2))
}